import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { User } from 'anchor-shared/lib/model/entity/user';
import { ConstantMan } from '../../../../core/services/constantMan';
import { Subject } from 'rxjs';
import { FormControl, FormGroup, Validators, NgForm } from '@angular/forms';

@Component({
  selector: 'app-customer-user-info-form',
  templateUrl: './customer-user-info-form.component.html',
  styleUrls: ['./customer-user-info-form.component.scss'],
})
export class CustomerUserInfoFormComponent implements OnInit {
  public toVerifyEmail: Subject<string> = new Subject<string>();
  userEditForm: FormGroup;

  @Input()
  user: User;

  @Output()
  onSaveClick = new EventEmitter<Partial<User>>();

  constructor() {}

  ngOnInit() {
    this.userEditForm = new FormGroup({
      firstName: new FormControl(this.user.firstName, [Validators.required]),
      lastName: new FormControl(this.user.lastName, [Validators.required]),
      email: new FormControl(this.user.email, [
        Validators.required,
        Validators.email,
      ]),
    });
    setTimeout(() => {
      this.toVerifyEmail.next(this.user.email);
    }, 1);
  }

  emailBlurred(emailString: string) {
    this.toVerifyEmail.next(emailString);
  }

  emailKeyupHandler(emailString: string) {
    this.toVerifyEmail.next(emailString);
  }

  saveClick(): void {
    if (!this.userEditForm.valid) {
      return;
    }
    this.onSaveClick.emit({
      firstName: this.userEditForm.controls.firstName.value,
      lastName: this.userEditForm.controls.lastName.value,
      email: this.userEditForm.controls.email.value,
    });
  }

  disableSubmit(form: FormGroup): boolean {
    if (
      !form.controls.firstName.valid ||
      !form.controls.lastName.valid ||
      this.userEditForm.pristine
    ) {
      return true;
    }
    return false;
  }
}
